<div class="col-lg-12 content-scroll-screen parent">
  <div class="row child">
    <p-card class="card-spacing-0">
      <span class="d-flex justify-content-between align-items-end m-3">
        <span class="col-auto d-flex gap-1 align-items-center head-custom-span">
          <h2 class="mb-0" *ngIf="viewSelected.id !== 3">
            Task Manager
            <!-- <jni-spinner *ngIf="showSmallLoader"></jni-spinner> -->
          </h2>
          <div class="gap-1 align-items-center d-flex inside-custom-span">
            <div class="col-auto">
              <span class="p-input-icon-right w-100-size searchbtn">
                <p-inputgroup>
                  <p-inputgroup-addon>
                    <i class="pi pi-search"></i>
                  </p-inputgroup-addon>
                  <input
                    pInputText
                    placeholder="Keyword"
                    title="Search by Title, Client, Job, Nickname, PO, Buyer, Supplier"
                    (keydown.enter)="onSubmit()"
                    (ngModelChange)="onSearchTextChange($event)"
                    [(ngModel)]="searchText" />
                  <p-inputgroup-addon
                    *ngIf="viewSelected.id === 1 && searchText"
                    class="clear-search-icon"
                    (click)="onClearSearchClick()">
                    <i class="pi pi-times"></i>
                  </p-inputgroup-addon>
                  <p-button label="Search" (click)="onSubmit()" />
                </p-inputgroup>
              </span>
            </div>

            <div
              *ngIf="
                bulkArchivedList.length > 0 &&
                bulkArchive &&
                !displayArchivedTasks
              "
              class="col-auto d-flex align-items-center"
              (click)="bulkArchiveEvent()">
              <a
                href="javascript:;"
                class="text-decoration-none d-flex align-items-center gap-1">
                <i class="pi pi-arrow-circle-up"></i
                ><span>Archive Selected</span>
              </a>
            </div>
            <div
              class="col-auto d-flex align-items-center gap-1 mt-1"
              *ngIf="showHideBulkArchiveOption">
              <h3 class="mb-0">Bulk Archived</h3>
              <p-toggleSwitch
                [(ngModel)]="bulkArchive"
                (onChange)="bulkArchived($event)"></p-toggleSwitch>
            </div>
            <div class="col-auto d-flex align-items-center gap-2 mt-1">
              <h3 class="mb-0">Archived</h3>
              <p-toggleSwitch
                [(ngModel)]="displayArchivedTasks"
                (onChange)="handleArchivedTasks($event)"></p-toggleSwitch>
            </div>
            <div
              class="col-auto d-flex align-items-center mt-1 gap-2"
              *ngIf="!isAdmin">
              <h3 class="mb-0">Team Tasks</h3>
              <p-toggleSwitch
                [(ngModel)]="displayMyTasks"
                (onChange)="handleTeamTasks($event)"></p-toggleSwitch>
              <h3 class="mb-0">My Tasks</h3>
            </div>
            <div class="col-auto mt-1" (click)="displaySettingModal = true">
              <a
                href="javascript:;"
                class="text-decoration-none d-flex align-items-center gap-1">
                <i class="pi pi-cog"></i><span>Settings</span>
              </a>
            </div>
            <div class="col-auto mt-1" (click)="displayFilterModal = true">
              <a
                href="javascript:;"
                class="text-decoration-none d-flex align-items-center gap-1">
                <i class="pi pi-filter"></i> <span>Filters</span>
              </a>
            </div>
            <div
              class="col-auto"
              (click)="clearFilters()"
              *ngIf="displayClearFilter">
              <a
                href="javascript:;"
                class="text-decoration-none d-flex align-items-center gap-1">
                <i class="pi pi-filter-slash"></i> <span>Clear Filters</span>
              </a>
            </div>
            <div
              class="col-auto d-flex gap-1 align-items-center"
              *ngIf="viewSelected.id !== 2">
              <p-radioButton
                (ngModelChange)="onChangeTaskType({ type: $event })"
                inputId="taskType1"
                name="taskType"
                value="0"
                [(ngModel)]="taskType"
                label="All Tasks"></p-radioButton>
              <label for="taskType1" class="mt-1">All Tasks</label>
            </div>
            <div class="col-auto d-flex gap-1 align-items-center">
              <p-radioButton
                (ngModelChange)="onChangeTaskType({ type: $event })"
                inputId="taskType2"
                name="taskType"
                value="{{ TaskTypeEnum.Sales }}"
                [(ngModel)]="taskType"
                label="Sales Tasks"></p-radioButton>
              <label for="taskType2" class="mt-1">Sales Tasks</label>
            </div>
            <div class="col-auto d-flex gap-1 align-items-center">
              <p-radioButton
                (ngModelChange)="onChangeTaskType({ type: $event })"
                inputId="taskType3"
                name="taskType"
                value="{{ TaskTypeEnum.Production }}"
                [(ngModel)]="taskType"
                label="Production Tasks"></p-radioButton>
              <label for="taskType3" class="mt-1">Production Tasks</label>
            </div>
            <div class="col-auto avatar-group">
              <p-avatarGroup label="P" class="gap-1 d-flex">
                <p-avatar
                  *ngFor="let user of allAssignedUserList.slice(0, 2)"
                  label="{{ user?.name?.charAt(0) || '' }}"
                  [style]="{
                    'background-color': getColor(user?.name || ''),
                    color: getTextColor(user.name || ''),
                  }"
                  shape="circle"
                  class="cursor-pointer"
                  (click)="getAssignedUserTasks(user)"
                  (mouseenter)="showAvatarPopover($event, user)"
                  (mouseleave)="hideAvatarPopover()"></p-avatar>
                <p-avatar
                  *ngIf="extraUserCount > 0"
                  [label]="'+' + extraUserCount"
                  [style]="{ 'background-color': '#DDDDDD', color: '#333333' }"
                  (click)="toggleUsersList()"
                  class="cursor-pointer"
                  shape="circle"></p-avatar>
              </p-avatarGroup>

              <div *ngIf="displayUsers" class="avatar-dropdown">
                <ul>
                  <li
                    class="d-flex gap-2 align-items-center mb-2 pb-2"
                    *ngFor="let listUser of remainingAssignedUsers"
                    (click)="getAssignedUserTasks(listUser)">
                    <p-avatar
                      label="{{ listUser?.name?.charAt(0) || '' }}"
                      [style]="{
                        'background-color': getColor(listUser?.name || ''),
                        color: getTextColor(listUser.name || ''),
                      }"
                      shape="circle"
                      (mouseenter)="showAvatarPopover($event, listUser)"
                      (mouseleave)="hideAvatarPopover()">
                    </p-avatar>
                    <span>
                      <h3 class="mb-0">{{ listUser?.name || "" }}</h3>
                      <p class="mb-0">{{ listUser?.title || "" }}</p>
                    </span>
                  </li>
                </ul>
              </div>
            </div>
            <div class="col-auto">
              <p-select
                optionLabel="name"
                [options]="viewTypes"
                [(ngModel)]="viewSelected"
                (onChange)="onViewChange($event)"
                placeholder="Select View">
              </p-select>
            </div>

            <p-select
              *ngIf="viewSelected.id === 3"
              [options]="durationTypes"
              (ngModelChange)="onChangeDuration($event)"
              [(ngModel)]="durationSelected"
              placeholder="Select Duration">
            </p-select>
          </div>
        </span>

        <span
          *ngIf="headerSearchText && viewSelected.id === 1"
          class="d-flex align-items-center gap-2 search-filter-indicator">
          <p-button
            label="Clear"
            severity="danger"
            [outlined]="true"
            icon="pi pi-times"
            size="small"
            (click)="clearSearchFilter()" />
          <span class="search-results-label">
            Results for "<strong>{{ headerSearchText }}</strong
            >"
          </span>
        </span>

        <span class="d-flex gap-2 customizefilter-btn right-custom-span">
          <div class="col-auto d-flex gap-1 align-items-center">
            <div class="lds-ring inline ms-2" *ngIf="showSmallLoader">
              <jni-spinner></jni-spinner>
            </div>

            <div class="col-auto"></div>
            <div class="col-auto" *ngIf="viewSelected.id === 1">
              <p-button
                label="Export Excel"
                icon="pi pi-download"
                (onClick)="exportExcel()" />
            </div>
            <div class="col-auto">
              <!-- <button
                type="button"
                (click)="showDialog()"
                class="btn btn-primary align-items-center">
                Add New Task
              </button> -->

              <p-button label="Add New Task" (click)="showDialog()" />
            </div>
            <div class="col-auto">
              <p-button
                label="Add New Project"
                (click)="openAddNewProjectModal()" />
            </div>
            <!-- <div class="col-auto">
              <button type="button" (click)="showDialogSummary()"
                      class="btn btn-primary align-items-center">
                Summary
              </button>
            </div> -->
          </div>
        </span>
      </span>

      <div class="col-12">
        <jni-task-sidebar
          *ngIf="displaySidebar"
          [display]="displaySidebar"
          [displayAddTaskModal]="displayAddTaskModal"
          (hideEvent)="hideSideBar()"></jni-task-sidebar>
        <jni-list-view
          #listViewComponent
          [myTasks]="displayMyTasks"
          [archivedTasks]="displayArchivedTasks"
          [globalFilter]="filterValue"
          [clearColumns]="clearColumns"
          [taskType]="taskType"
          (showClearFilter)="showClearFilter($event)"
          (displaySmallLoader)="displaySmallLoader($event)"
          [bulkArchive]="bulkArchive"
          (archivedList)="archivedListValues($event)"
          (disableBulkArchive)="handleDisableBulkArchive()"
          [allAssignedUserList]="allAssignedUserList"
          *ngIf="viewSelected.id === 1"
          [headerSearchText]="headerSearchText"></jni-list-view>
        <jni-calendar-view
          #calendarViewComponent
          [myTasks]="displayMyTasks"
          [archivedTasks]="displayArchivedTasks"
          [globalFilter]="filterValue"
          [taskType]="taskType"
          [durationSelected]="durationSelected"
          [allAssignedUserList]="allAssignedUserList"
          *ngIf="viewSelected.id === 3"
          (emitShowContactDialog)="showContactDialog($event)"
          (emitShowSalesOrderSummaryModal)="showOrderSummaryModal($event)"
          (emitShowWorkflowSummaryModal)="
            showWorkflowSummaryModal($event)
          "></jni-calendar-view>
        <jni-kanban-view
          #kanbanViewComponent
          [myTasks]="displayMyTasks"
          [archivedTasks]="displayArchivedTasks"
          [globalFilter]="filterValue"
          [taskType]="taskType"
          [allAssignedUserList]="allAssignedUserList"
          (emitShowContactDialog)="showContactDialog($event)"
          *ngIf="viewSelected.id === 2"></jni-kanban-view>
        <!-- <p-dialog
          contentStyleClass="mb-2 pb-2"
          [style]="{
            width: '80%',
            height: 'auto',
            overflow: 'hidden',
            maxHeight: 'fit-content',
          }"
          appendTo="body"
          [draggable]="false"
          [(visible)]="displayAddTaskModal"
          (onHide)="closeAddTask(false)">
          <ng-template #header>
            <div class="d-flex align-items-center gap-2">
              <h2 class="mb-0">Add Task</h2>
              <div
                class="lds-ring inline me-auto ms-2"
                *ngIf="showAddTaskSmallLoader">
                <jni-spinner></jni-spinner>
              </div>
            </div>
          </ng-template>
          <jni-task-header
            *ngIf="displayAddTaskModal"
            [showTaskHeader]="showTaskModal"
            (closeAddTask)="closeAddTask($event)"
            [taskIdSelected]="taskIdSelected"
            [buyer]="buyerName"
            (showContact)="showContactDialog($event)"
            (showAddNewProjectModal)="openAddNewProjectModal()"
            [reloadProjects]="reloadProjects"
            (showSmallLoaderEvent)="
              showOrHideAddTaskSmallLoader($event)
            "></jni-task-header>
        </p-dialog> -->
        <jni-task-header-edit
          #taskHeaderEditComponent
          *ngIf="displayAddTaskModal"
          [displayModal]="displayAddTaskModal"
          (closeAddTask)="closeAddTask($event)"
          [taskIdSelected]="taskIdSelected"
          [buyer]="buyerName"
          (showContact)="showContactDialog($event)"
          (showAddNewProjectModal)="openAddNewProjectModal()"
          [reloadProjects]="reloadProjects"
          (showSmallLoaderEvent)="showOrHideAddTaskSmallLoader($event)"
          [actionType]="'Add'"></jni-task-header-edit>

        <p-dialog
          [style]="{ width: '20%', height: '77%', maxHeight: '77%' }"
          appendTo="body"
          [(visible)]="displayFilterModal"
          (onHide)="closeFilter()">
          <jni-task-filter-popup
            (closeFilterPopUp)="closeFilter()"
            [taskType]="taskType"
            (showClearFilter)="showClearFilter($event)"
            (addFilterValues)="addFilterValues($event)"
            (assignedUsersEmitter)="receiveAssignedUsers($event)">
          </jni-task-filter-popup>
        </p-dialog>

        <p-dialog
          [style]="{ width: '450px', height: '470px', maxHeight: '470px' }"
          appendTo="body"
          [(visible)]="displaySettingModal"
          (onHide)="closeSetting()">
          <ng-template #header>
            <h2 class="mb-0">Setting</h2>
          </ng-template>
          <jni-task-global-setting
            (hide)="closeSetting()"
            (changeTaskType)="
              onChangeTaskType($event)
            "></jni-task-global-setting>
        </p-dialog>

        <div class="sidebar-iconposition">
          <a (click)="showOrHideSidebar()" class="link sidebar-close-icon">
            <i class="pi pi-angle-left"></i>
          </a>
        </div>
      </div>
    </p-card>
  </div>
</div>
<jni-add-contact-information
  #contactForm
  [(display)]="displayAddContact"
  *ngIf="displayAddContact"
  [headingStatus]="true"
  [isFromOrdersAddNewBuyer]="true"
  [addClientContact]="addClientContact"
  [customerAccountNumber]="clientId"
  (populateContactAddedInfo)="populateContactAddedInfo($event)">
</jni-add-contact-information>
<p-dialog
  header="New Project"
  [position]="'center'"
  [resizable]="false"
  [draggable]="false"
  [modal]="true"
  [(visible)]="showAddNewProjectModal"
  [style]="{ width: '300px' }">
  <jni-create-project-on-task
    #createProjectOnTask
    (closeModal)="closeAddNewProjectModal()"
    (refreshProjectGrid)="refreshProjectGrid($event)">
  </jni-create-project-on-task>
</p-dialog>
<jni-confirm-dialog
  [dialogMessage]="archiveMessage"
  headerMsg="Archive Confirmation"
  dialogHeading="Are you sure?"
  *ngIf="archiveAlertVisible"
  [hideIcon]="true"
  (confirmDialogStatus)="bulkArchiveConfirmEvent($event)">
</jni-confirm-dialog>

<p-popover
  #avatarUserPopover
  appendTo="body"
  (onShow)="keepPopoverOpen()"
  (onHide)="onAvatarLeave()"
  styleClass="avatar-popover-card">
  <jni-user-avatar-details
    *ngIf="showUserAvatarDetails"
    [userAvatorDetails]="userAvatorDetails"
    [isLoading]="isLoading"
    (mouseenter)="keepPopoverOpen()"
    (mouseleave)="hideAvatarPopover()"
    class="ratings-box overall userpophover">
  </jni-user-avatar-details>
</p-popover>

<jni-modal-stacker
  class="modal-header-sticky"
  *ngIf="ordersummaryDisplayModal"
  [displayModal]="ordersummaryDisplayModal"
  (closeEvent)="closeModalForSaleOrderSummary()">
  <h1 class="panelHeading">Order Summary</h1>
  <div class="panelBody">
    <jni-order-summary
      [isModal]="true"
      [orderType]="orderType"
      [saleOrderIdFromModal]="salesOrderIdForModal"
      (scrollHiddenStatus)="scrollHiddenStatus()"
      (closeOrderSummaryModalEvent)="
        closeModalForSaleOrderSummary()
      "></jni-order-summary>
  </div>
</jni-modal-stacker>

<jni-modal-stacker
  class="modal-header-sticky"
  *ngIf="showWorkflowSummaryDialog"
  [displayModal]="showWorkflowSummaryDialog"
  (closeEvent)="closeWorkflowSummaryModal()">
  <div class="panelBody">
    <jni-production-workflow-summary
      [salesOrderId]="salesOrderId"
      [workflowId]="workflowId"
      (scrollHiddenStatus)="scrollHiddenStatus()"
      (closeModalEvent)="closeWorkflowSummaryModal()">
    </jni-production-workflow-summary>
  </div>
</jni-modal-stacker>
